import React from 'react';
import { Card, CardContent, Box, Typography, Grid } from '@mui/material';
import { AttachMoney as CostIcon } from '@mui/icons-material';
import { formatCurrency } from './utils';

/**
 * CostAnalysisCard Component
 *
 * Displays cost analysis for a version.
 *
 * @param {Object} props
 * @param {Object} props.selectedVersion - Selected version data
 */
function CostAnalysisCard({ selectedVersion }) {
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <CostIcon color="primary" sx={{ mr: 1 }} />
          <Typography variant="h6">Cost Analysis</Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box textAlign="center">
              <Typography variant="h4" color="info.main">
                {formatCurrency(selectedVersion.total_cost)}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total Cost
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box textAlign="center">
              <Typography variant="h4" color="info.main">
                {formatCurrency(selectedVersion.avg_cost)}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Average Cost per Execution
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default CostAnalysisCard;
